import { Component, OnDestroy, OnInit } from '@angular/core';
import { IReservationData, ReservationService, SettingsService, ShopcartService } from 'core-lib';
import { ICartItem, IHotelInfo, IShopCart } from 'core-lib';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { LanguageService } from 'core-lib';
import { Subscription } from 'rxjs';
import { PIMService, PimNotificationComponent } from 'core-lib';
import { ConfirmationRoominfoComponent } from "../../components/confirmation-roominfo/confirmation-roominfo.component";
import { ConfirmationCommondetailsComponent } from "../../components/confirmation-commondetails/confirmation-commondetails.component";

@Component({
    selector: 'app-confirmation',
    imports: [TranslateModule, ButtonModule, ConfirmationRoominfoComponent, ConfirmationCommondetailsComponent, PimNotificationComponent],
    templateUrl: './confirmation.component.html',
    styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent implements OnInit, OnDestroy{

  language: string;
  rooms:ICartItem[]; 
  private subs: Subscription[] = [];
    
  reservations:IReservationData[];
  reservationFetchComplete:boolean = false;

  hotelInfo:IHotelInfo;
  countryList:any;

  websiteUrl:string|undefined;

  constructor(
    private shopCartService: ShopcartService, 
    private router:Router, 
    private languageService: LanguageService, 
    private pimService: PIMService, 
    private reservationService: ReservationService,
    private settings: SettingsService) {
    
  }

  ngOnInit(): void {
    this.language = this.languageService.getCurrentLanguage();

    this.subs.push(
      this.reservationService.getCurrentReservation().subscribe({
        next: (res:IReservationData[]) => {
          this.reservations = res;
          this.hotelInfo = this.pimService.getHotelInfo(this.reservations[0].roomRate.room?.hotelCode ?? this.reservations[0].hotelId);
        },
        complete: () => {
          this.reservationFetchComplete = true;
        }
      })
    );

    this.websiteUrl = this.settings.get('app.websiteUrl');   
    
  }

  newReservation() {
    this.shopCartService.clearShopCart();
    this.reservations = [];
    this.router.navigate(['home']);
  }

  print() {
    window.print();
  }

  goToWebsite() {
    if (this.websiteUrl) {
      document.location = this.websiteUrl;
    }
  }
 
  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe())
  }
}
